<template>
    
</template>
<script>
export default {
  name: 'testPage',
  data () {
    return {
    }
  },
  mixins: [],
  components: {
  },
  methods: {
    reset () {
      let url = decodeURIComponent('%2F%3Fda%3D23423')
      console.log('url', url)
      // this.$router.push(url)
    },
    handleRoute (route) {
      if (route.name === 'test') {
        this.reset()
      }
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}
</script>
